module.exports = "<ui-view></ui-view>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/nomina/components/configuracion/template.html
// module id = 1178
// module chunks = 0